import React, { useMemo } from 'react';
import { Text, View } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { isNativeIosAppStoreBranding } from '../../../src/worldcup/helpers/wcBrand.helper';
import { TOURNAMENT_IP_DISCLAIMER } from '../../../src/worldcup/worldcup.constants';
import { getWelcomeDisclaimerFooterStyles } from './WelcomeDisclaimerFooter.styles';

export interface WelcomeDisclaimerFooterProps {
  testID?: string;
}

export const WelcomeDisclaimerFooter: React.FC<WelcomeDisclaimerFooterProps> = ({ testID }) => {
  const theme = useTheme();
  const styles = useMemo(() => getWelcomeDisclaimerFooterStyles(theme), [theme]);

  if (!isNativeIosAppStoreBranding()) {
    return null;
  }

  return (
    <View style={styles.container} testID={testID}>
      <Text style={styles.text}>{TOURNAMENT_IP_DISCLAIMER}</Text>
    </View>
  );
};
